import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Radio,
  Input,
  Dropdown
} from 'semantic-ui-react'

const CardHolidayUX = (props: any) => {
    return(
      <div
        id="CardHolidayUX-div-0"
        style={{display: "flex"}}>
        <div
          className="--override-disabled --grey"
          id="CardHolidayUX-div-3"
          style={{flex: 1, padding: "5px"}}>

          <div
            id="CardHolidayUX-div-38"
            style={{display: "flex"}}>

            <Dropdown
              className="small หรผำ"
              fluid={true}
              id="CardHolidayUX-Dropdown-39"
              loading={props.isDivisionLoading??false}
              onChange={props.changeDivision}
              options={props.divisionOptions}
              placeholder="Please select the division"
              search={true}
              selectOnBlur={true}
              selection={true}
              value={props.selectedDivisionId}>
            </Dropdown>
          </div>
          <div
            id="CardHolidayUX-div-10"
            style={{margin: "5px", flex: 1, display: props.hideRadioGroup ? "none" : "flex", justifyContent: "flex-start", alignItems: "center"}}>

            <Radio
              checked={props.selected === "normal"}
              id="CardHolidayUX-Radio-7"
              label="หยุดคลีนิคทุกวันที่คณะหยุด (ตั้งวันหยุดเพิ่มได้)"
              name="radioGroup"
              onChange={props.onChangeRadio}
              value="normal">
            </Radio>
          </div>
          <div
            id="CardHolidayUX-div-12"
            style={{margin: "5px", flex: 1, display: props.hideRadioGroup ? "none" : "flex", justifyContent: "flex-start", alignItems: "center"}}>

            <Radio
              checked={props.selected === "manual"}
              id="CardHolidayUX-Radio-15"
              label="ตั้งวันหยุดคลีนิคเองทั้งหมด (ไม่หยุดตามวันหยุดคณะ)"
              name="radioGroup"
              onChange={props.onChangeRadio}
              value="manual">
            </Radio>
          </div>
          <div
            id="CardHolidayUX-div-17"
            style={{marginTop: "10px", display: props.hideCopyPaste ? "none":""}}>

            <Button
              color="blue"
              id="CardHolidayUX-Button-6"
              size="small">
              สำเนาวันหยุดคณะมาเป็นวันหยุดคลีนิค (Copy & Paste)
            </Button>
          </div>
          <div
            id="CardHolidayUX-div-18"
            style={{height: "50vh"}}>

            <div
              id="CardHolidayUX-div-19"
              style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(25, 1fr)","gridTemplateColumns":"repeat(30, 1fr)"}}>
              <div
                id="CardHolidayUX-div-20"
                style={{paddingTop: "5px", textAlign: "right", gridRow: "2/4", gridColumn: "1/12", }}>
                วันที่
              </div>
              <div
                id="CardHolidayUX-div-21"
                style={{ gridRow: "2/4", gridColumn: "13/31",}}>
                <div
                  id="CardHolidayUX-div-37">
                  {props.dateTextBox}
                </div>
              </div>
              <div
                id="CardHolidayUX-div-24"
                style={{paddingTop: "5px", textAlign: "right", gridRow: "8/10", gridColumn: "1/12", }}>
                รายละเอียด
              </div>
              <div
                id="CardHolidayUX-div-25"
                style={{ gridRow: "8/10", gridColumn: "13/31", }}>
                <Input
                  disabled={!props.selectedDivisionId}
                  fluid={true}
                  id="CardHolidayUX-Input-35"
                  onChange={props.setHolidayField("detail")}
                  value={props.detail}>
                </Input>
              </div>
              <div
                id="CardHolidayUX-div-26"
                style={{paddingTop: "5px", textAlign: "right", gridRow: "11/13", gridColumn: "1/12", }}>
                หมายเหตุ
              </div>
              <div
                id="CardHolidayUX-div-27"
                style={{ gridRow: "11/13", gridColumn: "13/31",}}>
                <Input
                  disabled={!props.selectedDivisionId}
                  fluid={true}
                  id="CardHolidayUX-Input-36"
                  onChange={props.setHolidayField("remark")}
                  value={props.remark}>
                </Input>
              </div>
              <div
                id="CardHolidayUX-div-28"
                style={{ gridRow: "14/17", gridColumn: "22/31", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
                <Button
                  color="green"
                  disabled={props.disableUpdate}
                  id="CardHolidayUX-Button-30"
                  onClick={props.updateHoliday}
                  size="small"
                  style={{width: "100%", height: "100%"}}>
                  อัพเดท
                </Button>
              </div>
              <div
                id="CardHolidayUX-div-29"
                style={{ padding: "5px", gridRow: "17/21", gridColumn: "1/31", border:  props.error ? "solid red 1px" : "", color: "red" }}>
                {props.error}
              </div>
              <div
                id="CardHolidayUX-div-31"
                style={{ gridRow: "14/17", gridColumn: "12/21", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
                <Button
                  color="orange"
                  disabled={!props.selectedDivisionId}
                  id="CardHolidayUX-Button-32"
                  onClick={props.clearHoliday}
                  size="small"
                  style={{width: "100%", height: "100%"}}>
                  เคลียร์
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div
          id="CardHolidayUX-div-11"
          style={{flex: 3, padding: "5px"}}>

          <Table
            data={props.holidayItems}
            getTrProps={props.rowProps}
            headers="ปี,เดือน,วัน,รายละเอียด,หมายเหตุ,ลบ"
            id="CardHolidayUX-Table-2"
            keys="year,month,day,detail,remark,deleteButton"
            showPagination={false}
            style={{height: "90vh"}}>
          </Table>
        </div>
      </div>
    )
}


export default CardHolidayUX

export const screenPropsDefault = {}

/* Date Time : Thu Jul 17 2025 22:35:40 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 2,
      "name": "Table",
      "parent": 11,
      "props": {
        "data": {
          "type": "code",
          "value": "props.holidayItems"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.rowProps"
        },
        "headers": {
          "type": "value",
          "value": "ปี,เดือน,วัน,รายละเอียด,หมายเหตุ,ลบ"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-Table-2"
        },
        "keys": {
          "type": "value",
          "value": "year,month,day,detail,remark,deleteButton"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"90vh\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "--override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{flex: 1, padding: \"5px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "สำเนาวันหยุดคณะมาเป็นวันหยุดคลีนิค (Copy & Paste)"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-Button-6"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Radio",
      "parent": 10,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.selected === \"normal\""
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-Radio-7"
        },
        "label": {
          "type": "value",
          "value": "หยุดคลีนิคทุกวันที่คณะหยุด (ตั้งวันหยุดเพิ่มได้)"
        },
        "name": {
          "type": "value",
          "value": "radioGroup"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeRadio"
        },
        "value": {
          "type": "value",
          "value": "normal"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px\", flex: 1, display: props.hideRadioGroup ? \"none\" : \"flex\", justifyContent: \"flex-start\", alignItems: \"center\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{flex: 3, padding: \"5px\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"5px\", flex: 1, display: props.hideRadioGroup ? \"none\" : \"flex\", justifyContent: \"flex-start\", alignItems: \"center\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Radio",
      "parent": 12,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.selected === \"manual\""
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-Radio-15"
        },
        "label": {
          "type": "value",
          "value": "ตั้งวันหยุดคลีนิคเองทั้งหมด (ไม่หยุดตามวันหยุดคณะ)"
        },
        "name": {
          "type": "value",
          "value": "radioGroup"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeRadio"
        },
        "value": {
          "type": "value",
          "value": "manual"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"10px\", display: props.hideCopyPaste ? \"none\":\"\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{height: \"50vh\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "label": "divgrid",
      "name": "div",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(25, 1fr)\",\"gridTemplateColumns\":\"repeat(30, 1fr)\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"5px\", textAlign: \"right\", gridRow: \"2/4\", gridColumn: \"1/12\", }"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"2/4\", gridColumn: \"13/31\",}"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียด"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"5px\", textAlign: \"right\", gridRow: \"8/10\", gridColumn: \"1/12\", }"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"8/10\", gridColumn: \"13/31\", }"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "value",
          "value": "หมายเหตุ"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"5px\", textAlign: \"right\", gridRow: \"11/13\", gridColumn: \"1/12\", }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"11/13\", gridColumn: \"13/31\",}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"14/17\", gridColumn: \"22/31\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "code",
          "value": "props.error"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px\", gridRow: \"17/21\", gridColumn: \"1/31\", border:  props.error ? \"solid red 1px\" : \"\", color: \"red\" }"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Button",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "อัพเดท"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disableUpdate"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-Button-30"
        },
        "onClick": {
          "type": "code",
          "value": "props.updateHoliday"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"14/17\", gridColumn: \"12/21\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Button",
      "parent": 31,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-Button-32"
        },
        "onClick": {
          "type": "code",
          "value": "props.clearHoliday"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Input",
      "parent": 25,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-Input-35"
        },
        "onChange": {
          "type": "code",
          "value": "props.setHolidayField(\"detail\")"
        },
        "value": {
          "type": "code",
          "value": "props.detail"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Input",
      "parent": 27,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.selectedDivisionId"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-Input-36"
        },
        "onChange": {
          "type": "code",
          "value": "props.setHolidayField(\"remark\")"
        },
        "value": {
          "type": "code",
          "value": "props.remark"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 21,
      "props": {
        "children": {
          "type": "code",
          "value": "props.dateTextBox"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-37"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Dropdown",
      "parent": 38,
      "props": {
        "className": {
          "type": "value",
          "value": "small หรผำ"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardHolidayUX-Dropdown-39"
        },
        "loading": {
          "type": "code",
          "value": "props.isDivisionLoading??false"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "placeholder": {
          "type": "value",
          "value": "Please select the division"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selectOnBlur": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.selectedDivisionId"
        }
      },
      "seq": 39,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 95,
  "isMounted": false,
  "memo": false,
  "name": "CardHolidayUX",
  "project": "cudent2",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
